// src/components/ScrollToTop.js

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {

    // منع المتصفح من حفظ حركة التمرير
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // إجبار الصفحة تروح لأعلى بمجرد تغيير الـ Route
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // مهم جداً
    });

  }, [pathname]);

  return null;
}
